'use client';

import React from 'react';

import { Accordion, Typography } from 'lighthouse';

import SectionHeading from '@/widgets/ServiceLanding/SectionHeading';

import { FaqProps } from './models';

const Faq = ({ badge = 'سوالات متداول', title, subtitle, items }: FaqProps) => {
    return (
        <section className='bg-gradient-to-b from-white to-sky-50/60 py-16 md:py-24'>
            <div className='mx-auto max-w-3xl px-4'>
                <SectionHeading badge={badge} title={title} subtitle={subtitle} />

                <div>
                    {items.map((item) => (
                        <div key={item.question} className='mb-4'>
                            <Accordion
                                typographyProps={{ variant: 'subtitle2', component: 'h3' }}
                                accordionShadow='elevation1'
                                accordionSummery={item.question}
                                component='div'>
                                <Typography variant='caption' component='p' className='leading-7 text-blackMediumEmphasis'>
                                    {item.highlights?.length
                                        ? item.answer
                                              .split(
                                                  new RegExp(
                                                      `(${item.highlights.map((text) => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})`,
                                                      'g'
                                                  )
                                              )
                                              .map((part, index) =>
                                                  item.highlights?.includes(part) ? (
                                                      <strong key={index} className='font-bold text-blackHighEmphasis'>
                                                          {part}
                                                      </strong>
                                                  ) : (
                                                      part
                                                  )
                                              )
                                        : item.answer}
                                </Typography>
                            </Accordion>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Faq;
